import { Box, Skeleton } from "@mui/material";
import useLanguages from "../../../../../explorer/hooks/useLanguages";
import { BasketItem } from "../../../../../explorer/types/Basket/BasketItems";
import { WarrantyItem } from "../../../../types";

type TPriceFormatComponentWithZero = {
    item: BasketItem | WarrantyItem;
    additionalProps?: any;
    colName: string;
};

const PriceFormatComponentWithZero = (props: TPriceFormatComponentWithZero) => {
    const lang = useLanguages().currentLanguage;
    const { item, additionalProps, colName } = props;
    const price = (
        item as {
            [key: string]: any;
        }
    )[colName];

    return (
        <Box>
            {Intl.NumberFormat(lang, {
                style: "currency",
                currency: item.currency ?? "EUR",
            }).format(Number(price))}
        </Box>
    );
};

export default PriceFormatComponentWithZero;
